var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00065,
    cy: 4.66667,
    r: 2.66667,
    stroke: "#ffbb00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95988 13.9179C1.99549 11.9182 4.04265 9.28756 8.04202 9.35878C9.27902 9.38081 10.3201 9.65446 11.1672 10.0812",
    stroke: "#ffbb00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.869 13.8689C13.8122 11.8697 11.7371 9.26097 7.73875 9.37471C6.50205 9.40988 5.46393 9.69458 4.62144 10.1303",
    stroke: "#ffbb00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIcon);
export default __webpack_public_path__ + "static/media/patient-icon.d311bc9d6dcc968063a0c3a51994cdf2.svg";
export { ForwardRef as ReactComponent };